import script from "./IdiChartSimulator.vue?vue&type=script&setup=true&lang=js"
export * from "./IdiChartSimulator.vue?vue&type=script&setup=true&lang=js"

import "./IdiChartSimulator.vue?vue&type=style&index=0&id=0e295bcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e295bcb"]])

export default __exports__